export type FrontofficeRuntime = 'web' | 'electron';

type RuntimeScope = {
  require?: unknown;
};

export function resolveFrontofficeRuntime(
  scope: RuntimeScope = globalThis as RuntimeScope,
): FrontofficeRuntime {
  return typeof scope.require === 'function' ? 'electron' : 'web';
}

export function supportsOfflinePos(runtime = resolveFrontofficeRuntime()): boolean {
  return runtime === 'electron';
}
